module.exports = __webpack_public_path__ + "assets/img/mosaic-columns-1.5008caae.jpg";